import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';
import QuoteForm from '../../components/base/QuoteForm';

const AboutPage = () => {
  return (
    <div className="min-h-screen">
      <Header />

      {/* Hero Section */}
      <section className="pt-32 pb-12 sm:pb-16 lg:pb-20 bg-gradient-to-br from-teal-50 via-orange-50 to-amber-50">
        <div className="container mx-auto px-4 sm:px-6">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 lg:gap-12 items-center">
            <div>
              <h1 className="text-3xl sm:text-4xl lg:text-6xl font-bold text-gray-900 mb-4 sm:mb-6 leading-tight">
                About <strong>NWA Gutter Guards</strong>
              </h1>
              <p className="text-base sm:text-lg lg:text-xl text-gray-600 mb-6 sm:mb-8 leading-relaxed">
                <strong>Northwest Arkansas's</strong> trusted experts in <strong>gutter protection</strong> and <strong>drainage solutions</strong>. Serving <strong>Fayetteville, Rogers, Bentonville, and Springdale</strong> with premium <strong>stone coated gutter caps</strong> and professional installation.
              </p>
              <div className="flex flex-col sm:flex-row gap-3 sm:gap-4">
                <a href="tel:479-337-7565" className="inline-flex items-center justify-center bg-gradient-to-r from-orange-500 to-orange-600 text-white px-6 sm:px-8 py-4 sm:py-4 rounded-lg text-base sm:text-lg font-semibold hover:from-orange-600 hover:to-orange-700 transition-all active:scale-95 touch-manipulation shadow-lg whitespace-nowrap min-h-[56px]">
                  <i className="ri-phone-line mr-2 text-xl"></i> Call (479) 337-7565
                </a>
                <a href="/contact" className="inline-flex items-center justify-center bg-white text-teal-600 border-2 border-teal-600 px-6 sm:px-8 py-4 sm:py-4 rounded-lg text-base sm:text-lg font-semibold hover:bg-teal-50 transition-all active:scale-95 touch-manipulation whitespace-nowrap min-h-[56px]">
                  Get Free Estimate
                </a>
              </div>
            </div>
            <div className="hidden lg:block">
              <img 
                src="https://public.readdy.ai/ai/img_res/cbfad52a1bea38c58c745da2ceafec2e.jpg"
                alt="NWA Gutter Guards professional team"
                className="w-full h-auto rounded-lg shadow-xl"
              />
            </div>
          </div>
        </div>
      </section>

      {/* Our Story */}
      <section className="py-12 sm:py-16 lg:py-20 bg-white">
        <div className="container mx-auto px-4 sm:px-6">
          <div className="max-w-4xl mx-auto">
            <div className="text-center mb-8 sm:mb-12">
              <h2 className="text-2xl sm:text-3xl lg:text-4xl font-bold text-gray-900 mb-3 sm:mb-4 leading-tight">
                Our Story
              </h2>
            </div>
            <div className="prose prose-sm sm:prose-base lg:prose-lg max-w-none">
              <p className="text-base sm:text-lg text-gray-600 mb-4 sm:mb-6 leading-relaxed">
                <strong>NWA Gutter Guards</strong> was founded with a simple mission: to protect <strong>Northwest Arkansas</strong> homes from water damage with the highest quality <strong>gutter protection systems</strong> available.
              </p>
              <p className="text-base sm:text-lg text-gray-600 mb-4 sm:mb-6 leading-relaxed">
                We've seen firsthand the damage that clogged gutters can cause—foundation problems, basement flooding, landscape erosion, and costly repairs. That's why we specialize in premium <strong>stone coated gutter caps</strong> that provide lifetime protection and eliminate the need for dangerous ladder climbing.
              </p>
              <p className="text-base sm:text-lg text-gray-600 leading-relaxed">
                Today, we're proud to be <strong>Northwest Arkansas's</strong> leading provider of <strong>gutter guard installation</strong>, <strong>seamless gutters</strong>, and <strong>drainage solutions</strong>, serving homeowners throughout <strong>Fayetteville, Rogers, Bentonville, and Springdale</strong>.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Why Choose Us */}
      <section className="py-12 sm:py-16 lg:py-20 bg-gradient-to-br from-amber-50 to-orange-50">
        <div className="container mx-auto px-4 sm:px-6">
          <div className="text-center mb-8 sm:mb-12">
            <h2 className="text-2xl sm:text-3xl lg:text-4xl font-bold text-gray-900 mb-3 sm:mb-4 leading-tight">
              Why Choose <strong>NWA Gutter Guards</strong>?
            </h2>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 sm:gap-8">
            <div className="bg-white rounded-lg shadow-md p-6 sm:p-8 hover:shadow-lg transition-shadow border-t-4 border-green-600">
              <div className="w-14 h-14 sm:w-16 sm:h-16 flex items-center justify-center bg-green-100 rounded-lg mb-4 sm:mb-6">
                <i className="ri-shield-star-line text-2xl sm:text-3xl text-green-600"></i>
              </div>
              <h3 className="text-lg sm:text-xl font-bold text-gray-900 mb-2 sm:mb-3">
                <strong>Premium Products</strong>
              </h3>
              <p className="text-base sm:text-base text-gray-600 leading-relaxed">
                We install only the highest quality <strong>stone coated gutter caps</strong> with lifetime warranties. No cheap alternatives or inferior products.
              </p>
            </div>

            <div className="bg-white rounded-lg shadow-md p-6 sm:p-8 hover:shadow-lg transition-shadow border-t-4 border-green-600">
              <div className="w-14 h-14 sm:w-16 sm:h-16 flex items-center justify-center bg-green-100 rounded-lg mb-4 sm:mb-6">
                <i className="ri-tools-line text-2xl sm:text-3xl text-green-600"></i>
              </div>
              <h3 className="text-lg sm:text-xl font-bold text-gray-900 mb-2 sm:mb-3">
                <strong>Expert Installation</strong>
              </h3>
              <p className="text-base sm:text-base text-gray-600 leading-relaxed">
                Our trained technicians ensure perfect installation every time. We take pride in our craftsmanship and attention to detail.
              </p>
            </div>

            <div className="bg-white rounded-lg shadow-md p-6 sm:p-8 hover:shadow-lg transition-shadow border-t-4 border-green-600">
              <div className="w-14 h-14 sm:w-16 sm:h-16 flex items-center justify-center bg-green-100 rounded-lg mb-4 sm:mb-6">
                <i className="ri-map-pin-line text-2xl sm:text-3xl text-green-600"></i>
              </div>
              <h3 className="text-lg sm:text-xl font-bold text-gray-900 mb-2 sm:mb-3">
                <strong>Local Expertise</strong>
              </h3>
              <p className="text-base sm:text-base text-gray-600 leading-relaxed">
                We understand <strong>Northwest Arkansas</strong> weather and its impact on gutters. Our solutions are designed for local conditions.
              </p>
            </div>

            <div className="bg-white rounded-lg shadow-md p-6 sm:p-8 hover:shadow-lg transition-shadow border-t-4 border-green-600">
              <div className="w-14 h-14 sm:w-16 sm:h-16 flex items-center justify-center bg-green-100 rounded-lg mb-4 sm:mb-6">
                <i className="ri-customer-service-line text-2xl sm:text-3xl text-green-600"></i>
              </div>
              <h3 className="text-lg sm:text-xl font-bold text-gray-900 mb-2 sm:mb-3">
                <strong>Outstanding Service</strong>
              </h3>
              <p className="text-base sm:text-base text-gray-600 leading-relaxed">
                From your first call to project completion, we provide friendly, professional service. Your satisfaction is our priority.
              </p>
            </div>

            <div className="bg-white rounded-lg shadow-md p-6 sm:p-8 hover:shadow-lg transition-shadow border-t-4 border-green-600">
              <div className="w-14 h-14 sm:w-16 sm:h-16 flex items-center justify-center bg-green-100 rounded-lg mb-4 sm:mb-6">
                <i className="ri-money-dollar-circle-line text-2xl sm:text-3xl text-green-600"></i>
              </div>
              <h3 className="text-lg sm:text-xl font-bold text-gray-900 mb-2 sm:mb-3">
                <strong>Fair Pricing</strong>
              </h3>
              <p className="text-base sm:text-base text-gray-600 leading-relaxed">
                Transparent, competitive pricing with no hidden fees. We provide detailed estimates so you know exactly what to expect.
              </p>
            </div>

            <div className="bg-white rounded-lg shadow-md p-6 sm:p-8 hover:shadow-lg transition-shadow border-t-4 border-green-600">
              <div className="w-14 h-14 sm:w-16 sm:h-16 flex items-center justify-center bg-green-100 rounded-lg mb-4 sm:mb-6">
                <i className="ri-time-line text-2xl sm:text-3xl text-green-600"></i>
              </div>
              <h3 className="text-lg sm:text-xl font-bold text-gray-900 mb-2 sm:mb-3">
                <strong>Timely Completion</strong>
              </h3>
              <p className="text-base sm:text-base text-gray-600 leading-relaxed">
                We respect your time and complete projects efficiently without sacrificing quality. Most installations done in one day.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Service Area */}
      <section className="py-12 sm:py-16 lg:py-20 bg-white">
        <div className="container mx-auto px-4 sm:px-6">
          <div className="max-w-4xl mx-auto text-center">
            <h2 className="text-2xl sm:text-3xl lg:text-4xl font-bold text-gray-900 mb-4 sm:mb-6 leading-tight">
              Proudly Serving <strong>Northwest Arkansas</strong>
            </h2>
            <p className="text-base sm:text-lg text-gray-600 mb-6 sm:mb-8 leading-relaxed">
              We provide professional <strong>gutter guard installation</strong> and <strong>drainage solutions</strong> throughout the region:
            </p>
            <div className="grid grid-cols-2 sm:grid-cols-4 gap-4 sm:gap-6 mb-8 sm:mb-12">
              <div className="text-center">
                <div className="w-14 h-14 sm:w-16 sm:h-16 flex items-center justify-center bg-green-100 rounded-full mx-auto mb-2 sm:mb-3">
                  <i className="ri-map-pin-line text-2xl sm:text-2xl text-green-600"></i>
                </div>
                <p className="text-base sm:text-base font-semibold text-gray-900"><strong>Fayetteville</strong></p>
              </div>
              <div className="text-center">
                <div className="w-14 h-14 sm:w-16 sm:h-16 flex items-center justify-center bg-green-100 rounded-full mx-auto mb-2 sm:mb-3">
                  <i className="ri-map-pin-line text-2xl sm:text-2xl text-green-600"></i>
                </div>
                <p className="text-base sm:text-base font-semibold text-gray-900"><strong>Rogers</strong></p>
              </div>
              <div className="text-center">
                <div className="w-14 h-14 sm:w-16 sm:h-16 flex items-center justify-center bg-green-100 rounded-full mx-auto mb-2 sm:mb-3">
                  <i className="ri-map-pin-line text-2xl sm:text-2xl text-green-600"></i>
                </div>
                <p className="text-base sm:text-base font-semibold text-gray-900"><strong>Bentonville</strong></p>
              </div>
              <div className="text-center">
                <div className="w-14 h-14 sm:w-16 sm:h-16 flex items-center justify-center bg-green-100 rounded-full mx-auto mb-2 sm:mb-3">
                  <i className="ri-map-pin-line text-2xl sm:text-2xl text-green-600"></i>
                </div>
                <p className="text-base sm:text-base font-semibold text-gray-900"><strong>Springdale</strong></p>
              </div>
            </div>
            <p className="text-base sm:text-base text-gray-600 leading-relaxed">
              And surrounding communities throughout <strong>Northwest Arkansas</strong>
            </p>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-12 sm:py-16 lg:py-20 bg-gradient-to-br from-green-700 via-green-800 to-green-900 text-white">
        <div className="container mx-auto px-4 sm:px-6">
          <div className="max-w-4xl mx-auto text-center">
            <h2 className="text-2xl sm:text-3xl lg:text-4xl font-bold mb-4 sm:mb-6 leading-tight">
              Ready to Protect Your Home?
            </h2>
            <p className="text-base sm:text-lg lg:text-xl mb-6 sm:mb-8 text-green-50 leading-relaxed">
              Contact <strong>NWA Gutter Guards</strong> today for a free estimate on <strong>gutter guard installation</strong> or any of our services.
            </p>
            <div className="flex flex-col sm:flex-row gap-3 sm:gap-4 justify-center">
              <a href="tel:479-337-7565" className="inline-flex items-center justify-center bg-gradient-to-r from-orange-500 to-orange-600 text-white px-6 sm:px-8 py-4 sm:py-4 rounded-lg text-base sm:text-lg font-semibold hover:from-orange-600 hover:to-orange-700 transition-all active:scale-95 touch-manipulation shadow-lg whitespace-nowrap min-h-[56px]">
                <i className="ri-phone-line mr-2 text-xl"></i> Call (479) 337-7565
              </a>
              <a href="/contact" className="inline-flex items-center justify-center bg-white text-green-700 px-6 sm:px-8 py-4 sm:py-4 rounded-lg text-base sm:text-lg font-semibold hover:bg-green-50 transition-all active:scale-95 touch-manipulation whitespace-nowrap min-h-[56px]">
                Request Free Quote
              </a>
            </div>
          </div>
        </div>
      </section>

      {/* Quote Form */}
      <section className="py-12 sm:py-16 lg:py-20 bg-gray-50">
        <div className="container mx-auto px-4 sm:px-6">
          <div className="max-w-2xl mx-auto">
            <QuoteForm 
              title="Ready to Protect Your Home?"
              subtitle="Get your free estimate today—no obligation, no pressure"
            />
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default AboutPage;
